// @flow
import * as React from 'react';
import LazyLoad from 'react-lazyload';
import { IMAGE_SIZE_320PX } from '../../../../components/shared/Images/Image/constants';
import Image from '../../../../components/shared/Images/Image';

type Props = {
  image: Object,
  placeholder: React.Node,
  lazyLoad?: ?boolean,
};

function SnippetPicture({ image, placeholder, lazyLoad }: Props) {
  const imageComponent = <Image image={image} preferredSize={IMAGE_SIZE_320PX} />;

  return lazyLoad ? (
    <LazyLoad once placeholder={placeholder}>
      {imageComponent}
    </LazyLoad>
  ) : (
    imageComponent
  );
}

SnippetPicture.defaultProps = {
  lazyLoad: false,
};

export default SnippetPicture;



// WEBPACK FOOTER //
// ./app/common/Snippet/shared/SnippetPicture/component.js